/* Whether a signed-in user may open a page.

   Every way into a dashboard -- the header menu, the home screen, the phone
   tabs, a deep link -- is derived in App.js from this one answer, so this is
   the whole rule. It lives in its own module so the rule can be tested with
   App.js's real permission maps without pulling the entire application into
   jsdom (permissionMaps.test.js does that).

   `access` is:
     isAdmin        the signed-in user is an admin
     permissions    Set of what the user holds (allowed_pages from /auth/me)
     overrides      page -> the permission it is checked under, where that is
                    not the page's own title (PAGE_PERMISSION_OVERRIDES)
     legacy         page -> older permission names that still open it
     explicitGrant  pages an admin does not open by being one
     alsoOpenedBy   page -> further grants that open it, for a page with a
                    part given on its own (Financial Statements' Term Debt
                    tab). The page shows only the parts the person holds. */
export function pageIsAllowed(page, { isAdmin, permissions, overrides, legacy, explicitGrant, alsoOpenedBy = {} }) {
  if (page === "Alerts") return true;
  const required = overrides[page];
  const alsoOpens = (alsoOpenedBy[page] || []).some((permission) => permissions.has(permission));
  // The grant itself or nothing: no admin fallback, no legacy names.
  if (explicitGrant.has(page)) return (Boolean(required) && permissions.has(required)) || alsoOpens;
  if (alsoOpens) return true;
  if (required) {
    return permissions.has(required) ||
      (legacy[page] || []).some((permission) => permissions.has(permission)) ||
      isAdmin;
  }
  return isAdmin || permissions.has(page);
}
